import { render, staticRenderFns } from "./SupportUsers.vue?vue&type=template&id=54c3c01e&scoped=true"
import script from "./SupportUsers.vue?vue&type=script&lang=js"
export * from "./SupportUsers.vue?vue&type=script&lang=js"
import style0 from "./SupportUsers.vue?vue&type=style&index=0&id=54c3c01e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3c01e",
  null
  
)

export default component.exports